import React                       from 'react';
import { connect }                 from 'react-redux';
import { Modal}                    from 'react-bootstrap';
import { SetError }                from '../../../actions/notificacaoAction';
import DesafiosProfessorLista      from './desafios_professor_lista';
import DesafiosProfessorEncerrados from './desafios_professor_encerrados';
import FormCadastro                from './form/desafios_cadastro';
import FormEditar                  from './form/desafios_editar';
import FormDuplicar                from './form/desafios_duplicar';
import { GetListaMenuTopo,
         GetListaSubMenuTopo,
         ActionModal }     from '../../../actions/scopoAction';

class Desafios_Professor extends React.Component {

    constructor(props){
        super(props);
        this.state = { 
                       showModal  : false,
                       load       : false,
                       dadosForm  : null,
                       formulario : 0,
                       text       : 'Adicionar desafio'
                      }                     
    }

    close(){
       this.setState({ 
                      showModal  : false,
                      dadosForm  : null,
                      formulario : 0,
                      text       : 'Adicionar desafio'
                     });
    }
        
    open(i,vetor,acao){   

      const obj = {}
        switch (acao) {
            case 1:
              obj.acao = "Editar desafio";
            break;

            case 2:
               obj.acao = "Duplicar desafio";
            break;
        
            default:
                obj.acao = "Adicionar desafio";
            break;
        }

       this.props.ActionModal(true);
       this.setState({
                      showModal  : true,
                      dadosForm  : (vetor >= 0 ? this.props.atividadesProfessor[vetor] : null ),
                      formulario : (vetor >= 0 ? acao : 0 ),
                      text       : obj.acao,
                    });
    }

    componentWillMount(){
        //Criando um estado com id da turma mais id da disciplina
        this.props.GetListaMenuTopo([
            {action:true,nome:"Home",link:this.props.menu.home},
            {action:true,nome:this.props.menu.desafios.nomeModulo,link:this.props.menu.desafios.home},
            {action:false,nome:"Turmas"}
           ]);


        this.props.GetListaSubMenuTopo([
            {nome:"No período",link : null},
            {nome:"Encerrado",link : 1},
          ]);
    } 

    componentWillReceiveProps(nextProps){
        if(nextProps.actionModal){
           this.setState({showModal: true });
        }else{
           this.setState({showModal: false });
        }
    }

    render(){

        const obj = {}
        switch (this.state.formulario) {
            case 0:
                obj.acao = <FormCadastro/>;            
            break;
            case 1:
                 obj.acao = <FormEditar DadosForm={this.state.dadosForm}/>;
            break;
            case 2:
                 obj.acao = <FormDuplicar DadosForm={this.state.dadosForm}/>;
            break;
            default:
               obj.acao = <h1>Nenhum componente selecionado.</h1>;
            break;
        }
   
        return (
            <div className="container-bg">
                <div className="titulo-pages topo_conteudo">
                  <span className="titulo">Desafios</span>
                </div>
                <DesafiosProfessorLista funcaoOpen={this.open.bind(this,null)}/>
                <Modal show={this.state.showModal} onHide={this.close.bind(this)} bsSize="large" backdrop="static">
                       {obj.acao}
                </Modal>
            </div>
        );
    }

}

function mapStateToProps(state){

    return {
      session             : state.auth.session,
      menu                : state.configReducer.menu,
      checkSelect         : state.scopoReducer.checkSelect,
      actionModal         : state.scopoReducer.actionModal,
      atividadesProfessor : state.atividadesReducer.allAtividadesLista
    }
}

export default connect(mapStateToProps,{ SetError,
                                         ActionModal,
                                         GetListaMenuTopo,
                                         GetListaSubMenuTopo})(Desafios_Professor);




// WEBPACK FOOTER //
// ./src/components/professor/desafios/desafios_professor.js